import { Injectable } from "@angular/core";

@Injectable()
export class PropostaService {

	public Canal: any = {};
	public IsSimulacao: any;
	public Processo: any = {};
	public ProcessoId: any;
	public PropostaId: any;
	public UsuarioId: any;

}


// WEBPACK FOOTER //
// ./src/services/proposta.service.ts